import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './services/AuthContext';
import HomePage from './components/HomePage';
import Login from './components/Login';
import Signup from './components/Signup';
import Dashboard from './components/Dashboard';
import AdminDashboard from './components/AdminDashboard';
import ProtectedRoute from './components/ProtectedRoute';
import ResetPassword from './components/ResetPassword';
import LabelDetails from './components/LabelDetails';
import About from './components/About';
import Contact from './components/Contact';
import EmailForm from './components/EmailForm';
import Payment from './components/Payment';
import ForgotPassword from './components/ForgotPassword';
import OrderDetails from './components/OrderDetails';
import UserSettings from './components/UserSettings';
import Test from './components/test';
import LandingPage from './components/LandingPage';
import PaymentSuccess from "./components/PaymentSuccess";
import CallScheduleSuccess from "./components/CallScheduleSuccess";
import FinalSuccess from "./components/FinalSuccess";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/forgotpassword" element={<ForgotPassword />} />
          <Route path="/labeldetails" element={<LabelDetails />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/email" element={<EmailForm />} />
          <Route path="/test" element={<Test />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/call-schedule-success" element={<CallScheduleSuccess />} />
        <Route path="/final-success" element={<FinalSuccess />} />
        
          <Route
            path="/payment"
            element={
              <ProtectedRoute>
                <Payment />
              </ProtectedRoute>
            }
          />
          <Route path="/order-details" element={<OrderDetails />} />
          <Route path="/user-settings" element={<UserSettings />} />
          <Route path="/landingpage" element={<LandingPage />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute role="admin">
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;